<template>
  <span
    v-if="stage == 'Hired'"
    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
  >
    {{ stage }}
  </span>
  <span
    v-else-if="stage == 'Declined' || stage == 'Disqualified' || stage == 'Unlicensed'"
    class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800"
  >
    {{ stage }}
  </span>
  <span v-else class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
    {{ stage }}
  </span>
</template>

<script>
export default {
  props: {
    stage: {
      type: String,
      required: true,
    },
  },
};
</script>
